import React from 'react'
import Props from 'prop-types'
import Arrow from './arrow.png';
import {FloatSelect} from '../../Common/Class/FloatLabelInput';
import Spinner from "react-spinner-material";
import Empty from "../../Common/fCard/Empty";

class PaginationTable extends React.Component {

	state = {
		page: 0
	}

	_headerItem = (item) => {

		let active = this.props.sort ? this.props.sort.type === item.key : false;

		if (item.type === "check") {
			return (
				<div key={item.key} style={{ width: 40, alignItems: 'center', display: 'flex' }}>
					<div onClick={item.click}
						style={{ width: 16, height: 16, border: '1px solid var(--border-color)', cursor: 'pointer' }}>
						<div style={item.checked ? {
							background: "var(--success-color)",
							width: 12,
							height: 12,
							margin: 1
						} : {}} />
					</div>
				</div>
			)
		}
		return (
			<div key={item.key}
				style={item.width ? { width: item.width } : item.weight ? { flex: item.weight } : { flex: 1 }}>
				<p onClick={item.sort ? item.sort : null} className="fintrip-table-header-title" style={{
					...item.style, ...item.sort ? {
						cursor: 'pointer'
					} : null
				}}>
					{item.name}
					{active ? (this.props.sort.up ?
						<img src={Arrow} alt="" style={{ height: 10, width: 10, marginLeft: 5 }} /> :
						<img src={Arrow} alt=""
							style={{ height: 10, width: 10, transform: 'rotate(180deg)', marginLeft: 5 }} />) : null}
				</p>
			</div>
		)
	}

	pagination = () => {
		let pagecount = this.props.pagecount?this.props.pagecount:15;
		let start = this.props.page * pagecount + 1;
		let end = this.props.page * pagecount + pagecount;
		let length = this.props.length
		if (end > length)
			end = length;
		if (start > length)
			start = length;

		if (this.props.pageLoading) {
			return (
				<div className="fintrip-table-footer" style={{
					alignItems: 'center'
				}}>
					<Spinner radius={36} visible={true} color="var(--primary-color)" />
				</div>
			)
		}

		return (
			<div className="fintrip-table-footer" style={{
				alignItems: 'center',
				marginTop:10
			}}>
				<img style={{ cursor: 'pointer' }} onClick={() => {
					let page = this.props.page;
					if ((start + pagecount) <= (length)) {
						this.props.fetch(page + 1)
					}
				}} alt="left arrow" className="right-arrow" src={require('./right-arrow (2).png')} />
				<img style={{ cursor: 'pointer' }} onClick={() => {
					let page = this.props.page;
					if (page > 0) {
						this.props.fetch(page - 1)
					}
				}} alt="right arrow" className="left-arrow" src={require('./left-arrow (1).png')} />
				<p>
					{start} - {end} of {length} results
				</p>

				{this.selectPage()}
			</div>
		)
	}


	selectPage = () => {
		let list = [{ value: 1, key: 1 }];
		let length = (this.props.length / 15) / 5;
		for (let i = 1; i <= length; i++) {
			list.push({
				value: 5 * i,
				key: 5 * i
			})
		}
		return (
			<div style={{
				marginRight: 60,
				display: 'flex',
				alignItems: 'center',
				width: 120
			}}>
				<p style={{
					fontWeight: 600,
					fontSize: 14,
					marginRight: 20
				}}>
					Page
				</p>

				<FloatSelect
					items={list}
					labelInput={{
						height: 36,
						width: 70
					}}
					defaultValue={this.props.page}
					onChange={(val) => {						
						this.props.fetch(Number(val));

					}}
					handleRef={() => {

					}}
				/>

			</div>
		)
	}


	render() {
		let data = this.props.data ? this.props.data : [];
		return (
			<div className={`fintrip-table ${this.props.portlet ? 'portlet-table' : ""}`}>
				<div className="fintrip-table-header" style={this.props.headerStyle}>
					{this.props.headers.map(this._headerItem)}
				</div>
				<div className="fintrip-table-body">
					{data.map((item, i) => {
						return (
							<div key={i}>{this.props.mapItem(item, i)}</div>
						)
					})}
					{data.length === 0 ?
						<p style={{ padding: 18, textAlign: 'center' }}>No data found to show.</p> : null}
				</div>
				{
					this.pagination()
				}
			</div>
		)
	}

}

PaginationTable.propTypes = {
	headers: Props.array.isRequired,
	mapItem: Props.func,
	data: Props.array.isRequired,
	portlet: Props.bool,
	page: Props.number,
	length: Props.number
}

PaginationTable.defaultProps = {
	portlet: false
}



class PaginationTable2 extends React.Component {

	state = {
		page: 0
	}


	pagination = () => {
		let pagecount = 15;
		let start = this.props.page * pagecount + 1;
		let end = this.props.page * pagecount + pagecount;
		let length = this.props.length
		if (end > length)
			end = length;
		if (start > length)
			start = length;

		if (this.props.pageLoading) {
			return (
				<div className="fintrip-table-footer" style={{
					alignItems: 'center'
				}}>
					<Spinner radius={36} visible={true} color="var(--primary-color)" />
				</div>
			)
		}

		return (
			<div style={{position:'relative',padding:'0px 12px',paddingRight:30}}>
				<div className="fintrip-table-footer" style={{
					position:'absolute',
					right:0,
					top:-20
				}}>
					<img style={{ cursor: 'pointer' }} onClick={() => {
						let page = this.props.page;
						if ((start + pagecount) <= (length)) {
							this.props.fetch(page + 1)
						}
					}} alt="left arrow" className="right-arrow" src={require('./right-arrow (2).png')} />
					<img style={{ cursor: 'pointer' }} onClick={() => {
						let page = this.props.page;
						if (page > 0) {
							this.props.fetch(page - 1)
						}
					}} alt="right arrow" className="left-arrow" src={require('./left-arrow (1).png')} />
					<p>
						{start} - {end} of {length} results
					</p>

					{this.selectPage()}
				</div>
				<div style={{
						fontWeight: 'bold',
						fontSize: 13,
						display: 'flex',
						alignItems: 'center',
						flexGrow: 10
				   }}>
					{
				      this.props.children
					}
				</div>
			</div>
		)
	}


	selectPage = () => {
		let list = [{ value: 1, key: 1 }];
		let length = (this.props.length / 15) / 5;
		for (let i = 1; i <= length; i++) {
			list.push({
				value: 5 * i,
				key: 5 * i
			})
		}
		return (
			<div style={{
				marginRight: 60,
				display: 'flex',
				alignItems: 'center',
				width: 120
			}}>
				<p style={{
					fontWeight: 600,
					fontSize: 14,
					marginRight: 20
				}}>
					Page
				</p>

				<FloatSelect
					items={list}
					labelInput={{
						height: 36,
						width: 70
					}}
					onChange={(val) => {
						this.props.fetch(Number(val));

					}}
					handleRef={() => {

					}}
				/>

			</div>
		)
	}


	render() {
		let data = this.props.data ? this.props.data : [];
		return (
			<div style={{position:'relative'}}>
				{
					this.pagination()
				}
				<div className="fintrip-office-container">
					{data.map((item, i) => {
						return (
							<div key={i}>{this.props.mapItem(item, i)}</div>
						)
					})}
					{data.length === 0 ? <Empty/>: null}
				</div>
			</div>
		)
	}

}

PaginationTable2.propTypes = {
	mapItem: Props.func,
	data: Props.array.isRequired,
	portlet: Props.bool,
	page: Props.number,
	length: Props.number
}

PaginationTable2.defaultProps = {
	portlet: false
}

const stateUtils = (state, data, page) => {
	return {
		...state,
		...data,
		loading: false,
		page,
		total: data.total ? data.total : state.total
	}
}

const getApprovalFiltersData = (data) => {
	let filters = []
	data.forEach(item => {
		let type = item.type;
		type = type.toLowerCase();
		if (type === "office") {
			type = "employee.officeId"
		}
		if (type === "department") {
			type = "employee.departmentId"
		}
		if (type === "code") {
			type = "employee.code"
		}
		filters.push(`${item.value}@${type}`)
	})
	return filters;
}

const getVoucherFiltersData = (data) => {
	let filters = []
	data.forEach(item => {
		let type = item.type;
		type = type.toLowerCase();
		if (type === "office") {
			type = "office_id"
		}
		if (type === "department") {
			if(window.location.href.includes('history/declined')){
				type = "department_id"
			}else{
				type = "employee.department.id"
			}
		}
		if (type === "code") {
			if(window.location.href.includes('offline/history') && !window.location.href.includes('declined')){
				type = 'employee.code'
			}else{
				type = 't0.employee_id'
				item.value = item.id
			}
		}
		if (type === 'voucherid') {
			type = "voucher_id"
		}
		if (type === 'voucher type') {
			type = 'type'
		}
		if(type === 'status'){
			type = 't0.status'
		}
		if(type === 'entity'){
			filters.push(`entityId=${item.value}`)
		} else {
			filters.push(`${item.value}@${type}`)
		}
	})
	return filters;
}


const getInvoiceFiltersData = (data) => {
	let filters = []
	data.forEach(item => {
		let type = item.type;
		type = type.toLowerCase();
		if (type === "office") {
			type = "office_id"
		}
		if (type === "department") {
			type = "department_id"
		}
		if (type === "code") {
			type = "employee_code"
		}
		filters.push(`${item.value}@${type}`)
	})
	return filters;
}


const getVendorFilterData = (data) => {
	let filters = []
	data.forEach(item => {
		let type = item.type;
		type = type.toLowerCase();
		if (type === "office") {
			type = "office_id"
		}
		if (type === "department") {
			type = "department_id"
		}
		if (type === "code") {
			type = "employee_code"
		}
		filters.push(`${item.value}@${type}`)
	})
	return filters;
}

const getStockFilterData = (data) => {
	let filters = [];
	data.forEach(item=>{
		let type  = item.type;
		type= type.toLowerCase();
		if(type==='office') {
			type='address_id'
		}

		filters.push(`${item.value}@${type}`)
	})

	return filters;
}

const getStockOfficeData = (data) => {
	let filters = [];
	data.forEach(item=>{
		let type  = item.type;
		type= type.toLowerCase();
		let value = item.label;
		if(type==='office') {
			type='id';
			value = item.value;
		}

		filters.push(`${value}@${type}`)
	})

	return filters;
}

const getExpensesData = (data) => {
	let filters = []
	data.forEach(item => {
		let type = item.type;
		type = type.toLowerCase();
		if (type === "office") {
			type = "office_id"
		}
		if (type === "department") {
			filters.push(`${item.label}@${'t0.department_name'}`)
		}
		if (type === "code") {
			type = "employee_code"
		}
		if (type === 'transaction') {
			type = "trans_id"
		}
		if (type === 'service') {
			type = 'service'
		}
		if(type==='employee name') {
			type= 'owner_id'
		}
		if(type==='team') {
			type= 'owner.levelId'
		}
		if(type==='team employee') {
			type = 't0.owner_id'
		}
		
		if(type ==='employee name') {
			filters.push(`${item.id}@${type}`)
		} else if(type==='voucher_id') {
			filters.push(`0>voucher_id`)
		} else  if(type !== 'department') {
			filters.push(`${item.value}@${type}`)
		}
	})

	return filters;
}


const getOfflineExpenseData = (data) => {
	let filters = []
	data.forEach(item => {
		let type = item.type;
		type = type.toLowerCase();
		if (type === "office") {
			type = "office_id"
		}
		if (type === "status") {
			type = "expense_status"
		}
		if (type === "department") {
			type = "department_id"
		}
		if (type === "code") {
			type = "employee_code"
		}
		if (type === 'transaction') {
			type = "trans_id"
		}
		if (type === 'service') {
			type = 'service'
		}
		filters.push(`${item.value}@${type}`)
	})
	return filters;
}

const getSettlementFilterData = (data) => {
	let filters = [];
	data.forEach(item => {
		
		let type = item.type;
		if (type === 'code') {
			type = "owner_id"
			filters.push(`${item.id}@${type}`)
		} else if(type === 'invoice id') {
			filters.push(`INVOICES@reference_type`);
			filters.push(`${item.mId}@reference_id`)
			filters.push('PARTIAL@reference_type')
		} else if(type==='office') {
			filters.push(`${item.value}@t0.office_id`)
		} else if(type==='vendor') {
			filters.push(`CONTACT@owner_type`);
			filters.push(`${item.value}@owner_id`)
		}  else if(type==='purchase order') {
			filters.push(`${item.id}@po_id`)
		} else if(type==='ledger id') {
			type = "ledger_id"
			filters.push(`${item.value}@${type}`)
		} else if(type==='account') {
			filters.push(`${item.value}@va_key`)
		} else if(item.label==='ICICI') {
			filters.push(`1@${item.id}`)
		} else if(item.label==='SCB') {
			filters.push(`0@${item.id}`)
		} else if(type==='status') {
			type = "status"
			filters.push(`${item.id}@${type}`)
		}else if(type === "entity"){
			filters.push(`@entityId@${item.value}`)
		}else if(type === "vendor advance") {
			filters.push(`${item.id}@referenceId`)
		} else if(type === 'voucher id') {
			filters.push(`${item.id || item.value}@reference_id`)
		} else if(type==='category') {
			filters.push(`${item.id}@vc_category_id`)
		}
		else {
			filters.push(`${item.id}@${type}`)
		}
	})
	return filters;
}

const getQrFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type;
		if (type === 'code') {
			type = "employee.code"
		} else if (type === 'office') {
			type = 'employee.officeId'
		} 
		filters.push(`${item.value}@${type}`)
	})
	return filters;
}

const getLedgerFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type;
		let value = item.value;
		if (type === "qr") {
			type = "reference_id";
		} else if (type === "code") {
			type = "t0.employee_id";
			value = item.id;
		} else if (type === "type") {
			type =  "type";
		}
		filters.push(`${value}@${type}`)
	})
	return filters;
}

const getPrFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type;


		if (type === 'code') {
			type = 'owner_id'
		} else if (type === 'office') {
			type = 'office_id'
		} else if (type === 'purchase id') {
			type = 'purchase_id'
		} else if (type === 'purchase order') {
			type = 'order_id'
		} else if(type==='request id') {
			type="request_id"
		} else if(type==='rfq id'|| type==='rfq title') {
			type="purchase_id"
		} else if(type === 'vendor') {
			type='vendor_id'
		} else if(type === 'employee name') {
			type='owner_id'
		} else if (type==='grn user') {
			type="grn_id"
		} else if (type==='invoice user') {
			type="owner_id"
		} else if(type==='category') {
			type="category_id"
		}  else if(type==='super category') {
			type="super_category_id"
		} else if(type==='title'|| type==='pr title') {
			type="name"
		} 
		if(item.value==='integration_failed')	filters.push(`1@integration_failed`)
		else if(item.value==='1@po_created' || item.value==='0@po_created'){
			filters.push(`${item.value}`)
		}else if (type === 'owner_id') {
			filters.push(`${item.id}@${type}`)
		} else if (type === 'delivery_date') {
			filters.push(`${item.value}<${type}`)
		}else if(type === 'by tag'){
			filters.push(`${item.value}`)
		}else if(type==='ownerId'){
			filters.push(`${item.value}@${type}`)
			filters.push(`ADMIN@ownerType`)
		}
		else {
			filters.push(`${item.value}@${type}`)
		}


	})
	return filters;
}


const getEmployeesFilterData = (data) => {
	let filters = []
	data.forEach(item => {
		
		let type = item.type.toLowerCase();
		let value = item.value;
		if (type === "office") {
			type = "office_id"
		} else if (type === "department") {
			type = "department_id"
		} 
		if(type==='status') {
			filters.push(`${value}@${type}`)
		} else {
			filters.push(`${value}@${type}`.toLowerCase())
		}
	})
	return filters;
}


const getAdvanceRequestFilter = (data) => {
	let filters = []
	data.forEach(item => {
		let type = item.type.toLowerCase();
		let value = item.value;
		if (type === "office") {
			type = "office_id"
		} else if (type === "department") {
			type = "department_id"
		} else if(type==='code') {
			type="employee_id";
			value= item.id
		}
		filters.push(`${value}@${type}`.toLowerCase())
	})
	return filters;
}

const getAdvanceFilter = (data) => {
	let filters = []
	data.forEach(item => {
		let type = item.type.toLowerCase();
		if (type === "office") {
			type = "office_id"
		} else if (type === "department") {
			type = "department_id"
		} else if(type==='code') {
			type="employee_id"
		} else if ( type === 'mjp') {
			type = 'mjp_id'
		}

		if(item.type==='code') {
			filters.push(`${item.id}@${type}`.toLowerCase())
		} else {
			filters.push(`${item.value}@${type}`.toLowerCase())
		}
	})
	return filters;
}

const getPastFilter = (data) => {
	let filters = []
	data.forEach(item => {
		let type = item.type.toLowerCase();
		filters.push(`${item.value}@${type}`.toLowerCase())
	})
	return filters;
}

const getAccessFilter = (data) => {
	let filters = []
	data.forEach(item => {
		let type = item.type.toLowerCase();
		if (type === 'voucher type') {
			type = 'type'
		}
		filters.push(`${item.value}@${type}`.toLowerCase())
	})
	return filters;
}


const getEmployeesDeleteFilterData = (data) => {
	let filters = [];
	data.forEach(item => {
		filters.push(`${item.value}@${item.type}`)
	})
	return filters;
}

const getLinkedAccountFilter = (data) => {
	let filters = [];
	
	data.forEach(item => {
		let type = item.type.toLowerCase();
		if (type === 'office') {
			type = "office_id";
			filters.push(`${item.value}@${type}`);
		} else if (type === 't0.due_at') {
			filters.push(`${item.value}<${type}`)
			filters.push(`0>t0.due_at`)
		} 
		else if (type === 'consumer id') {
			filters.push(`${item.value}@consumer`)
		}
		else if(type === 'biller category'){
			filters.push(`${item.value}@t0.service`)
		}
		else if(type === 'metertype'){
			filters.push(`${item.value}@meterType`)
		}
		else if(type === 'connectiontype'){
			filters.push(`${item.value}@connectionType`)
		}
		else {
			filters.push(`${item.value}@${type}`);
		}
		
	})
	return filters;
}

const getAllContactFilter = (data,custom=false,sendAsCustomFields=[]) => {
	let filters = [];

	if(!custom) {
		data.filter(i=>!(i.fieldMaster || sendAsCustomFields.includes(i.type))).forEach(item => {
			let type = item.type.toLowerCase();
			if (type === 'gstin') {
				type = 'gstin'
			}
			if (type === 'vendor code') {
				type = 'registered_id'
			}
			if (type === 'productid') {
				type = 'product_id'
			}
			
			if(type === 'hsn') {
				type='hsn'
			}
			if (type === 'title') {
				type = 'title'
			}
			if (type === 'vendor name') {
				type = 'name'
			}
			if(type === 'vendor category') {
				type = 'category'
			}
			if(type === 'category') {
				type = 'category_id'
			}
			if(type === 'product name') {
				filters.push(`${item.id}@id`)
			} else {
				filters.push(`${item.value}@${type}`)
			}
	
		})
	} 

	if(custom) {
		data.filter(i=>(i.fieldMaster || sendAsCustomFields.includes(i.type))).forEach(item => {
			let type = item.type.toLowerCase();
			if (type === 'gstin') {
				type = 'gstin'
			}
			if (type === 'vendor code') {
				type = 'registered_id'
			}
			if (type === 'productid') {
				type = 'product_id'
			}
			
			if(type === 'hsn') {
				type='hsn'
			}
			if (type === 'title') {
				type = 'title'
			}
			if (type === 'vendor name') {
				type = 'name'
			}
			if(type === 'vendor category') {
				type = 'category'
			}
			if(type === 'category') {
				type = 'category_id'
			}
			if(type === 'product name') {
				filters.push(`${item.id}@id`)
			} else {
				filters.push(`${item.value}@${type}`)
			}
	
		})
	}
	
	return filters;
}

 

const getAllContractFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type.toLowerCase();
		if (type === 'vendor') {
			type = 'vendor_id';
		}
		if(type==='contract id') {
			type="contract_id"
		}
		if (type === "status") {
			type = "status";
			if(item.value==='HOLD')	type = 't0.status';
		}
		if(type === 'office') {
			type= 'office_id'
		}
		if(type === 'category') {
			type= 'category_id'
		}
		filters.push(`${item.value}@${type}`);
	})
	return filters;
}

const getAllAsnFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type.toLowerCase();
		let value = item.value;
		if (type === 'vendor name') {
			type = 'vendor.name';
			filters.push(`${value}@${type}`);
		}
		if(type==='purchase order') {
			value = item.id
			type="po_id"
		}
		if(type === 'asn') {
			type= 't0.asn_id'
			filters.push(`${value}@${type}`);
		}
	})
	return filters;
}

const getAllGinFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type.toLowerCase();
		let value = item.value;
		if (type === 'vendor name') {
			type = 'vendor.name';
			filters.push(`${value}@${type}`);
		}
		if(type==='purchase order') {
			value = item.id
			type="order_id"
			filters.push(`${value}@${type}`);
		}
		if(type === 'gin') {
			type= 't0.gin_id'
			filters.push(`${value}@${type}`);
		}
	})
	
	return filters;
}

const getAllAsnFilter1 = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type.toLowerCase();
		if(type==='purchase order') {
			filters.push(item.id)
		}
	})
	return filters;
}


const getAllTEFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type;
		if (type === 'code') {
			type = 'owner_id'
		}

		if (type === 'vendorid') {
			type = 'invoice_id'
		}

		if (type === 'vendor service') {
			type = 'service'
		}

		if (type === 'vendor name') {
			type = 'name'
		}

		if(type==='invoice id') {
			type= "invoice_id"
		}

		if (type === 'gstin') {
			type = 'vendor.gstin'
		}
		if (type === 'pan') {
			type = 'vendor.pan'
		}
		if(type==='vendor') {
			type='t0.vendor_id'
		}
		if (type === 'owner_id') {
			filters.push(`${item.id}@${type}`)
		}
		else if (type === 'due_date') {
			filters.push(`${item.value}<${type}`)
		}
		else if (type === 'updated_at') {
			filters.push(`${item.value}>t0.${type}`)
		}
		else if(type==='purchase order') {
			filters.push(`${item.id}@po_id`)
		} else if(type === 'billing address') {
			filters.push(`${item.value}@office_id`)
		} else if(item.value==='SETTLEMENT_PENDING') {
			filters.push(`COMPLETED@t0.status`);
			filters.push(`0@settlement.settled`);
		} else if(item.value==='COMPLETED') {
			filters.push(`COMPLETED@t0.status`);
			filters.push(`1@settlement.settled`);
		} else if(item.value === 'CREDIT_NOTE_REQUIRED') {
			filters.push(`1@credit_note_required`);
		} else if(item.type === 'customStatus'){
			filters.push(`${item.value}~t0.violations`)
		} else if(type==='bill number') {
			filters.push(`${item.value}@bill_number`)
		} else if(item.type === 'category'){
			filters.push(`${item.value}@category_id`)
		} else if(type === 'asn') {
			type= 'asn.asnId'
			filters.push(`${item.value}@${type}`);
		}	else if(type === 'entity') {
			type= 'office.entity_id'
			filters.push(`${item.value}@${type}`);
		} else if(type === '>t0.po_id') {
			filters.push(`${item.value}${type}`);
		}
		 else {
			filters.push(`${item.value}@${type}`)
		}

	})

	return filters;

	
}

const getAllVendorAdvanceFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type.toLowerCase();
		let value = item.value;
		if (type === "category") {
			type = 'vc_category_id';
		} else if (type === "advance id") {
			type = 'advance_id';
		}
		filters.push(`${value}@${type}`)
	})
	return filters;
}

const getAllRenewalFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type.toLowerCase();
		let value = item.value;
		if (type === 'purchase order') {
			type = 'po_id';
			value = item.id;
		} else if(type==='vendor') {
			type="vendor_id"
		} else if(type==='office') {
			type="office_id"
		}
		if(type === 'product name') {
			filters.push(`${item.id}@product_id`)
		} else {
			filters.push(`${value}@${type}`)
		}

	})
	return filters;
}


const getBudgetFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type.toLowerCase();
		let value = item.value;
		if (type === 'budget id') {
			type = 'budget_id';
		} 
		if (type === 'budget title') {
			type = 'budgetCategory.title';
		}
		if(type === 'template id'){
			type = 'title'
		}
		filters.push(`${value}@${type}`)


	})
	return filters;
}
const getCreditNoteFilter = (data) => {
	let filters = [];
	data.forEach(item => {
		let type = item.type.toLowerCase();
		if (type === 'code') {
			type = 'owner_id';
		} 
		if (type === 'invoice id') {
			type = 'invoice_id';
		} 
		if (type === 'vendorid') {
			type = 'vendor_id';
		} 
		if (type === 'vendor service') {
			type = 'service';
		} 
		if (type === 'vendor') {
			type = 'vendor_id';
		}if (type === 'gstin') {
			type = 'vendor.gstin';
		}if (type === 'creditnote id') {
			type = 'id';
		} 
		

		if (type === 'owner_id') {
			filters.push(`${item.id}@${type}`)
		}
		else if (type === 'invoice_id') {
			filters.push(`${item.mId}@${type}`)
		}
		else if (type === 'vendor_id') {
			filters.push(`${item.value}@t0.${type}`)
		}else if (type === 'id') {
			filters.push(`${item.value}@${type}`)
		}
		else if(type==='service'){
			filters.push(`${item.value}@${type}`)
		}
		else if(type==='vendor.gstin'){
			filters.push(`${item.value}@${type}`)
		}
	})
	return filters;
}



export {
	PaginationTable,
	PaginationTable2,
	getVoucherFiltersData,
	getApprovalFiltersData,
	stateUtils,
	getEmployeesFilterData,
	getExpensesData,
	getOfflineExpenseData,
	getInvoiceFiltersData,
	getVendorFilterData,
	getSettlementFilterData,
	getEmployeesDeleteFilterData,
	getLinkedAccountFilter,
	getAllContactFilter,
	getAllTEFilter,
	getQrFilter,
	getPrFilter,
	getStockFilterData,
	getStockOfficeData,
	getAdvanceFilter,
	getAllContractFilter,
	getAllRenewalFilter,
	getLedgerFilter,
	getBudgetFilter,
	getAdvanceRequestFilter,
	getPastFilter,
	getAllAsnFilter,
	getAllAsnFilter1,
	getCreditNoteFilter,
	getAllVendorAdvanceFilter,
	getAccessFilter,
	getAllGinFilter
}
